import React, { useContext } from "react";
import styled from "styled-components";
import Stat from "./Stat";
import { DFB_CATS } from "../../Graphics/BasicPack/PlayerStats";
import { ScrollBar } from "../../Theme/Hyper";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { UIContext } from "../../contexts/UIContext";

const Main = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  font-size: 0.8em;
  max-height: 40vh;
  overflow-y: auto;
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;

export default function SportecPlayerStatsComparison({
  game,
  homePlayer,
  awayPlayer,
}) {
  const { previewGraphic } = useContext(GraphicsContext);
  const { periods } = useContext(UIContext);
  const homeStats = game?.sportec_player_stats?.home?.find(
    (p) => p?.player === homePlayer?.dfb_ID,
  );
  const awayStats = game?.sportec_player_stats?.away?.find(
    (p) => p?.player === awayPlayer?.dfb_ID,
  );

  let period = {};
  if (periods?.length > 0) {
    period = periods?.sort((a, b) => b.number - a.number)?.[0];
  }

  return (
    <Main>
      {DFB_CATS.map((cat) => (
        <Row key={cat.title}>
          <Stat
            game={game}
            category={cat.title}
            stat={{
              home: cat?.calc({ stats: homeStats?.stats }) || 0,
              away: cat?.calc({ stats: awayStats?.stats }) || 0,
            }}
            onCategoryClick={() => {
              previewGraphic("PlayerStatsComparison", {
                homePlayer,
                awayPlayer,
                game,
                customStatTitle: cat.title,
                homeCustomStatValue: cat?.calc({ stats: homeStats?.stats }),
                awayCustomStatValue: cat?.calc({ stats: awayStats?.stats }),
                customStatType: cat.statType,
                period,
              });
            }}
          />
        </Row>
      ))}
    </Main>
  );
}
